import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {mate} from 'genetix/Flip.js';
import {loadParameterFromJson, saveParameterToJson} from 'parameters/parameterJsonFunctions.js';

class FMModulatorOscillator {
    constructor(sequencerEngine, mixSession, context, fmSynth) {
        this.sequencerEngine = sequencerEngine;
        this.store = sequencerEngine.store;
        this.mixSession = mixSession;
        this.context = context.getCopy().forSubDevice(this);

        this.fmSynth = fmSynth;

        this.parameters = [];
        this.setupParameters();
    }

    get synth() {
        return this.fmSynth.synth;
    }

    setupParameters() {
        this.oscillatorTypeParameter = new AbstractParameter(
            'Oscillator Type', this,
            (o, x) => o.synth.set({
                "modulation": {
                    "type": x,
                },
            }),
            {
                min: 0,
                max: 1,
                unit: '',
                defaultValue: 'triangle',
                automatable: false
            });

        this.registerParameter(this.oscillatorTypeParameter);

        this.partialCountParameter = new AbstractParameter(
            'Partial Count', this,
            (o, x) => o.synth.set({
                "modulation": {
                    "partialCount": x,
                },
            }),
            {
                min: 0,
                max: 16,
                unit: '',
                defaultValue: 0,
            });

        this.registerParameter(this.partialCountParameter);
    }

    get oscillatorType() {
        return this.oscillatorTypeParameter.get();
    }

    set oscillatorType(type) {
        this.oscillatorTypeParameter.set(type);
    }

    get partialCount() {
        return this.partialCountParameter.get();
    }

    set partialCount(c) {
        return this.partialCountParameter.set(c);
    }

    refreshParameters() {
        this.oscillatorType = this.oscillatorType;
    }

    registerParameter(parameter, signalGetter) {
        parameter.setStore(this.store);
        parameter.setMixSession(this.mixSession);
        parameter.setContext(this.context);
        parameter.setTrack(this.context.track);
        this.parameters.push(parameter);
    }

    getJson() {
        let json = {
            oscillatorType: this.oscillatorType,
            partialCount: this.partialCount
        };
        
        json = saveParameterToJson(json, 'partialCountParameter', this.partialCountParameter);
        return saveParameterToJson(json, 'oscillatorTypeParameter', this.oscillatorTypeParameter);
    }

    fromJson(json) {
        this.oscillatorType = json.oscillatorType;
        if (json.partialCount) {
            this.partialCount  = json.partialCount;
        }

        loadParameterFromJson(json, 'oscillatorTypeParameter', this.oscillatorTypeParameter);
        loadParameterFromJson(json, 'partialCountParameter', this.partialCountParameter);
    }

    mateJson(partner, probability) {
        this.mateParameter('partialCount', partner, this.partialCountParameter, probability);
        this.mateParameter('oscillatorType', partner, this.oscillatorTypeParameter, probability);
    }

    mateParameter(name, data, param1, probability) {
        mate(this.sequencerEngine, name, data, param1, probability);
    }
}

export default FMModulatorOscillator;
